import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHero } from "@/components/site/PageHero";
import { Section } from "@/components/site/Section";
import { AdvisorCTA } from "@/components/site/AdvisorCTA";
import { caseStudies, caseStudiesIndex as c } from "@/content/case-studies";
import { SITE_URL } from "@/lib/seo";

export const Route = createFileRoute("/case-studies/")({
  head: () => ({
    links: [{ rel: "canonical", href: `${SITE_URL}/case-studies/` }],
    meta: [
      { title: c.metaTitle },
      { name: "description", content: c.metaDescription },
      { property: "og:title", content: c.metaTitle },
      { property: "og:description", content: c.metaDescription },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/case-studies/` },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: CaseStudiesPage,
});

function CaseStudiesPage() {
  return (
    <>
      <PageHero maxWidth="6xl" headline={c.headline} supporting={c.intro} />
      <Section tone="default">
        <div className="grid gap-6 md:grid-cols-2">
          {caseStudies.map((s) => (
            <article
              key={s.slug}
              className="flex flex-col overflow-hidden rounded-2xl border border-border/60 bg-background transition-all hover:-translate-y-1 hover:border-primary/30 hover:shadow-brand"
            >
              <img
                src={s.image}
                alt={s.imageAlt}
                loading="lazy"
                className="aspect-[16/9] w-full object-cover"
              />
              <div className="flex flex-1 flex-col p-7">
                <p className="text-xs font-semibold uppercase tracking-wider text-primary">
                  {s.kind}
                </p>
                <p className="mt-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                  {s.cardEyebrow}
                </p>
                <h2
                  className="mt-3 text-xl font-semibold leading-snug text-ink"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {s.cardTitle}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{s.cardBody}</p>
                <dl className="mt-5 grid grid-cols-2 gap-4 border-t border-border/60 pt-5">
                  {s.cardFacts.map((f) => (
                    <div key={f.label}>
                      <dt className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
                        {f.label}
                      </dt>
                      <dd className="mt-1 text-sm font-semibold text-ink">{f.value}</dd>
                    </div>
                  ))}
                </dl>
                <Link
                  to="/case-studies/$slug/"
                  params={{ slug: s.slug }}
                  className="mt-6 inline-flex w-fit items-center rounded-[6px] bg-[#693D94] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#693D94]/90"
                >
                  Read case study
                </Link>
              </div>
            </article>
          ))}
        </div>
      </Section>
      <AdvisorCTA
        title={c.ctaTitle}
        body={c.ctaBody}
        primaryLabel={c.ctaLabel}
        primaryTo="/contact/"
        secondaryLabel="View the Course Catalog"
        secondaryTo="/course-catalog/"
      />
    </>
  );
}
